import { CompanyDistrictDto } from './company-district.dto';

export class CompanyDistrictCreateDto extends CompanyDistrictDto {
  amenityIds?: number[];
}
